<template>
  <div>
    <v-container fluid grid-list-md class="pa-0 ma-0" :style="{ width: '100% !important' }">
      <v-layout wrap align-center>
        <v-flex class="form-control">
          <input v-model="query" type="text" :placeholder="$t('Search')" class="ma-0" />
        </v-flex>
        <v-flex shrink>
          <v-layout wrap align-center>
            <v-flex shrink>
              <v-btn outline color="grey" :loading="isExporting" class="ma-0" @click="exportData()">
                <v-icon>ios_share</v-icon>
                {{ $t('export') }}
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn color="primary" class="ma-0" @click="handleAdd">
                <v-icon>add</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <DepartmentTable
      :items="items"
      :total="total"
      :pagination.sync="pagination"
      :loading="isLoading"
      class="mt-3"
      @edit="handleEdit"
      @delete="handleDelete"
    />

    <FormDialog :value="editedItem" :open.sync="isFormDialogOpen" @success="handleFormSuccess" />
  </div>
</template>

<script>
import { debounce } from 'lodash'
import tigerpolyApi from '@/api/tigerpoly'
import { mapGetters } from 'vuex'
import DepartmentTable from './DepartmentTable.vue'
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'
import FormDialog from './FormDialog.vue'

export default {
  components: { DepartmentTable, FormDialog },
  data() {
    return {
      items: [],
      total: 0,
      filters: {
        name: '',
        page: 1,
        limit: 10
      },
      query: '',
      editedItem: null,
      isLoading: false,
      isExporting: false,
      isFormDialogOpen: false,
      debouncedSearch: debounce(this.search, 500)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pagination: {
      get() {
        return { page: this.filters.page, rowsPerPage: this.filters.limit }
      },
      set({ page, rowsPerPage: limit }) {
        this.filters = { ...this.filters, page, limit }
      }
    }
  },
  watch: {
    query(value) {
      if (value !== this.filters.name) {
        this.debouncedSearch()
      }
    },
    filters() {
      this.fetchItems()
    }
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const response = await tigerpolyApi.getDepartments({
          params: {
            page_id: this.selectedBot.pageid,
            limit: this.filters.limit,
            offset: (this.filters.page - 1) * this.filters.limit,
            name: this.filters.name
          }
        })

        if (response.status === 200) {
          this.items = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    search() {
      this.filters = { ...this.filters, name: this.query }
    },
    handleAdd() {
      this.editedItem = null
      this.isFormDialogOpen = true
    },
    handleEdit(item) {
      this.editedItem = item
      this.isFormDialogOpen = true
    },
    async handleDelete(item) {
      const { value: isConfirmed } = await this.$swal.fire({
        title: this.$t('department_delete_question', { name: item.name }),
        type: 'question',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel')
      })

      if (isConfirmed) {
        try {
          this.$store.state.loading = true

          const response = await tigerpolyApi.deleteDepartment({
            data: {
              id: item.id,
              page_id: item.page_id
            }
          })

          if (response.status === 204) {
            this.filters = { ...this.filters }
          }
        } catch (error) {
          console.error(error)
          if (error.response) {
            this.$swal.fire(error.response.data.message, undefined, 'error')
          }
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    handleFormSuccess() {
      this.isFormDialogOpen = false
      if (this.editedItem) {
        this.filters = { ...this.filters }
      } else {
        this.filters = { ...this.filters, page: 1 }
      }
    },
    async exportData() {
      try {
        this.isExporting = true

        const response = await tigerpolyApi.getDepartments({
          params: {
            page_id: this.selectedBot.pageid,
            limit: 1000000,
            offset: 0,
            name: this.filters.name
          }
        })

        if (response.status !== 200) return

        const rows = [
          [`Date ${dayjs().format('DD/MM/YYYY')}`],
          ['Department management'],
          [],
          ['ลำดับ', 'ตำแหน่ง'],
          ...response.data.data.map((item, itemIndex) => [(itemIndex + 1).toString(), item.name])
        ]

        const worksheet = XLSX.utils.aoa_to_sheet(rows)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Department management')
        XLSX.writeFile(workbook, `department-management-${Date.now()}.xlsx`)
      } catch (error) {
        console.error(error)
      } finally {
        this.isExporting = false
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/department/Department.vue